const sections = document.querySelectorAll('section.investment-schedule');

if (sections.length) {
    sections.forEach(section => {
        const buttons = section.querySelectorAll('[js-stage-button]');
        const files = section.querySelectorAll('[js-stage-files]');
        const scrollParent = section.querySelector('[js-stage-tabs]');

        const scrollButtonToCenter = button => {
            if (!scrollParent) return;

            const isScrollable =
                scrollParent.scrollWidth > scrollParent.clientWidth;

            if (!isScrollable) return;

            const wrapperRect = scrollParent.getBoundingClientRect();
            const buttonRect = button.getBoundingClientRect();
            const currentScroll = scrollParent.scrollLeft;
            const targetScroll =
                currentScroll +
                (buttonRect.left - wrapperRect.left) -
                (wrapperRect.width / 2 - buttonRect.width / 2);

            scrollParent.scrollTo({
                left: Math.max(0, targetScroll),
                behavior: 'smooth',
            });
        };

        const setActiveStage = (button, index) => {
            buttons.forEach(item => item.classList.remove('-active'));
            files.forEach(item => item.classList.remove('-active'));
            button.classList.add('-active');
            files[index].classList.add('-active');

            requestAnimationFrame(() => {
                scrollButtonToCenter(button);
            });
        };

        if (buttons.length) {
            buttons.forEach((button, index) => {
                button.addEventListener('click', () => {
                    setActiveStage(button, index);
                });
            });
        }
    });
}
